import axios from "axios";
import React, { Component } from "react";
import { browserHistory } from "react-router";
import { TOKEN } from "../../../utils/constants/localstoregeConstants";

class AutoLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("token");
    const userId = queryParams.get("userid");
    const clientId = queryParams.get("clientId");

    localStorage.setItem("client_id", clientId);

    var post = {
      token_id: id,
      client_id: clientId,
    };
    if (id && id !== "" && userId && userId != "") {
      axios
        .post("/api/periodical_auto_login", post)
        .then(function (response) {
          if (response.data != "" && response.data != null) {
            // Store token in localStorage
            localStorage.setItem(TOKEN, response.data.result.token_id);
            
            // Store user data for header component
            if (response.data.result) {
              localStorage.setItem("user_data", JSON.stringify({
                first_name: response.data.result.first_name,
                last_name: response.data.result.last_name,
                email: response.data.result.email,
                user_id: response.data.result.user_id
              }));
            }
            
            // Use setTimeout to ensure localStorage is persisted before navigation
            setTimeout(function() {
              // Navigate to dashboard without reload - let React Router handle it
              browserHistory.push("/dashboard");
              
              // Force reload after a short delay to ensure clean state
              setTimeout(function() {
                window.location.reload();
              }, 100);
            }, 50);
          }
        })
        .catch(function (error) {
          // Handle error - redirect to login
          browserHistory.push("/");
        });
    } else {
      // Invalid parameters - redirect to login
      browserHistory.push("/");
    }
  }

  render() {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: 'linear-gradient(to bottom, #1e5a8e 0%, #1e5a8e 40%, #e8edf2 40%, #e8edf2 100%)'
      }}>
        <div style={{
          background: '#ffffff',
          borderRadius: '12px',
          padding: '40px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
          textAlign: 'center',
          maxWidth: '400px'
        }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #e8edf2',
            borderTop: '4px solid #1e5a8e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <h3 style={{ color: '#1e5a8e', marginBottom: '10px' }}>Authenticating...</h3>
          <p style={{ color: '#6c7a89', fontSize: '14px' }}>Please wait while we log you in</p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }
}

export default AutoLogin;



// WEBPACK FOOTER //
// ./src/shared/containers/autoLogin/index.js